import BaseController from "@base/baseController.js";
import CockpitPage from "./components/CockpitPage.js";
import { findSection, DEFAULT_SECTION_ID } from "./cockpitSections.js";
import router from "@/services/router.js";

/**
 * Cockpit module controller: mounts the admin shell for one section.
 *
 * The Cockpit has no data of its own — each panel talks to its own module's
 * controller (gallery, showcase) or API endpoint — so there is no manager here.
 * An unknown or missing section id redirects to the first registered section
 * rather than rendering an empty shell.
 */
class CockpitController extends BaseController {
  async showPage(container, lang, sectionId) {
    const section = findSection(sectionId);
    if (!section) {
      router.replace(`/cockpit/${DEFAULT_SECTION_ID}`);
      return null;
    }
    this.view = new CockpitPage({ lang, section });
    await this.view.mount(container);
    return this.view;
  }
}

export default new CockpitController();
